import React from "react";
import CommonHeadingBeforeAfterLine from "../../../Common-Component/CommonHeadingBeforeAfterLine/CommonHeadingBeforeAfterLine";
import "./DesignGuidlineComponent.css";

const DesignGuidlineComponent = ({ product }) => {
  const data = [
    {
      step: "Choose A Template & Get Started",
      stepDescn:
        'Browse Our Collection Of Design Templates And Choose Your Template By Clicking On "Create Your Design"',
    },
    {
      step: "Personalize & Brand Your Design",
      stepDescn:
        "Make The Design Your Own By Incorporating Your Company Logo And Company Name.",
    },
    {
      step: "Add To Cart And Checkout",
      stepDescn:
        "Add Your Custom Design To The Cart And Checkout. To Complete Your Purchase.",
    },
  ];

  const sizeData = [
    {
      title: "Bleed Size",
      color: "#212021",
      size: '3.62 * 2.12"',
      sizeInMM: "92* 54 mm",
    },
    {
      title: "Final Size",
      color: "#F30503",
      size: '3.62 * 2.12"',
      sizeInMM: "92* 54 mm",
    },
    {
      title: "Safety Area",
      color: "#266403",
      size: '3.62 * 2.12"',
      sizeInMM: "92* 54 mm",
    },
  ];

  return (
    <section className="DesignGuidlineComponent">
      <div class="design_heading_div">
        <p class="heading_text">
          Design & Print With Ease Using Our Free Templates
        </p>
      </div>

      <div className="design_steps_card_holder">
        <img
          src={process.env.REACT_APP_IMG_URL + product?.design_image}
          className="safe_area_img"
        />
        {/* <div className='row'>
                    {data?.map((item, index) => {
                        return (
                            <div className='col-lg-4 col-md-4 col-sm-6'>
                                <div className='design_step_card'>
                                    <div className='heading_div'>
                                        <p className='step_no'>Step {index + 1}:</p>
                                        <p className='step_text'>{item?.step}</p>
                                    </div>

                                    <div className='step_decn_div'>
                                        <p className='step_descn_text'>
                                            {item?.stepDescn}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                </div> */}
      </div>

      <div className="descign_guidlines_main_div">
        {/* <CommonHeadingBeforeAfterLine headingText="Design Guidelines" /> */}

        {/* <div className='safe_area_img_holder'>
                    <img src="\assets\Images\designGuidlines\img.png" className='safe_area_img' />
                </div>

                <div className='safety_area_size_div'>
                    <div className='row'>
                        {sizeData?.map((item) => {
                            return (
                                <div className='col-lg-4 col-md-4 col-sm-4 col-6 mb-sm-0 mb-3'>
                                    <div className='row'>
                                        <div className='col-lg-6 '>
                                            <div className='size_box_div'>
                                                <div className='size_box' style={{ background: item?.color }}></div>
                                                <div className='size_name_div'>
                                                    <p className='size_name'>
                                                        {item?.title}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-lg-6'>
                                            <div className='size_in_number_div'>
                                                <p className='size_text'>{item?.size}</p>
                                                <p className='sizemm_text'>{item?.sizeInMM}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div> */}

        <div className="instruction_div">
          <div className="text1_div">
            <p className="text1">
              - Use The Bleed Size Of Your Design To Avoid White Edges
            </p>
          </div>
          <div className="text2_div">
            <p className="text2">
              - Keep Images And Text Within The Safety Area
            </p>
          </div>
        </div>

        <p className="download_text">Download Ready Files</p>

        <div className="footer_btn_holder">
          {product?.Product_Downloads?.map((val, index) => (
            <a
              key={index}
              href={process.env.REACT_APP_IMG_URL + val?.file} // Adjust the file path based on your API response
              download
              target="_blank"
              rel="noopener noreferrer"
              className="round_gray_btn"
              style={{ textDecoration: "none" }}
            >
              <p className="text">{val?.Download_Type?.name}</p>
            </a>
          ))}

          {/* <div className='round_gray_btn'>
                        <p className='text'>PSD</p>
                    </div>

                    <div className='round_gray_btn'>
                        <p className='text'>AI</p>
                    </div> */}
        </div>
      </div>
    </section>
  );
};

export default DesignGuidlineComponent;
